<!-- Convenios Editar -->

<p-panel header="{{ 'PERFILRIESGO.LBL_CAMBIOPERFIL' | translate}}">


  <div class="grid dashboard">
    <div class="lg:col-12">

      <div class="user-card p-shadow-content">
        <div class="user-card-header">
          <img alt="" src="assets/layout/images/dashboard/user-card-header.jpg"/>
        </div>

        <div class="user-card-content">
          <!-- Nombre Completo -->
          <div class="user-card-name" style="padding-top: 2rem;"><span>{{tercero ? tercero.nombreCompleto : '' }}</span></div>

          <div class="user-detail">
            <div class="grid">
              <!-- Documento -->
              <label class="col-12"><strong>{{'LBL_NUMERODOCUMENTO' | translate}}:</strong>
                {{ tercero ? tercero.tipoDocumento : '' }}
                - {{ tercero ? tercero.numeroDocumento : '' }}</label>
              <!-- Ocupación -->
              <label class="col-12"><strong>{{'VINCULACIONTERCERO.LBL_TIPOOCUPACION' | translate}}:</strong>
                {{tercero ? tercero.tipoOcupacion : null}}</label>
              <!-- Actividad -->
              <label class="col-12"><strong>{{'RADICACIONPRODUCTO.LBL_ACTIVIDADECONOMICA' | translate}}:</strong>
                {{tercero ? tercero.actividadEconomica : null}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr/>

  <form [formGroup]="formulario" (ngSubmit)="guardar()" id="formModel" name="formModel" *ngIf="formulario">

    <div class="grid">

      <!-- Imagen principal -->
      <div class="col-4">
        <div style="display: initial;float: right;text-align: center;">
          <label class="control-label"><strong>{{ 'PERFILRIESGO.LBL_PERFILACTUAL' | translate }}: </strong></label><br>
          <img alt="" [src]="imagenPpal ? imagenPpal : '/assets/images/perfil/avatar.jpg'" style="width: 100px" alt="perfil actual"/>
        </div>

      </div>

      <!-- Dropdown Riesgo -->
      <div class="col-4">
        <div class="div-form">
          <label class="control-label"><strong>{{ 'PERFILRIESGO.LBL_CAMBIARPERFILRIESGOA' | translate }}: </strong></label>
          <p-dropdown disableTab  id="idPerfilRiesgo" name="idPerfilRiesgo" [options]="listaPerfilesRiesgos"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" (onChange)="cargarImagen($event)"
                       formControlName="idPerfilRiesgo"></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idPerfilRiesgo.invalid">
            {{'PERFILRIESGO.LBL_CAMBIARPERFILRIESGOA' | translate}} {{'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>

      <!-- Imagen nueva -->
      <div class="col-4">
        <div style="display: initial;float: left;text-align: center;">
          <label class="control-label"><strong>{{ 'PERFILRIESGO.LBL_PERFILNUEVO' | translate }}: </strong></label><br>
          <img [src]="imagenNueva ? imagenNueva : '/assets/images/perfil/avatar.jpg'" style="width: 100px" alt="perfil actual"/>
        </div>
      </div>

    </div>

    <!-- Observaciones -->
    <div class="grid">

      <div class="col-12">
        <div class="div-form">
          <label for="observacion"><strong>{{ 'PERFILRIESGO.LBL_OBSERVACIONES' | translate }}</strong></label>
          <textarea id="observacion" name="observacion" pInputTextarea rows="2"
                    capitalize-reactive maxlength="500" formControlName="observacion"></textarea>
        </div>
      </div>

      <!-- Guardar -->
      <div class="col-12 form-footer-buttons">
        <div class="form-group" *ngIf="!guardando">
          <a (click)="cancelar()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
          <button pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate}}" type="submit"></button>
        </div>

        <div class="form-group " *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-fw"></i>
          <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
        </div>
      </div>

    </div>


  </form>

</p-panel>

<p-confirmDialog #cd key="cambio-perfil-editar">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
